const useGetProvidersPage = () => {
    return async ({filters, searchText, page, userInteractionSearch}) => {
        let filterParams = ''

        if (filters) {
            for (const filter of Object.values(filters)) {
                if (filter.touched && filter.valid) {
                    switch (filter.type) {
                        case 'order':
                            if (true) {
                            }
                            break
                        case 'multi-select':
                            switch (filter.config.variant) {
                                case 'list':
                                    if (true) {
                                        for (const entry in filter.value) {
                                            filterParams = `${filterParams}${filter.APIField}=${filter.value[entry]}&`
                                        }
                                    }
                                    break
                                case 'dropdown':
                                    if (true) {
                                        for (const entry of filter.value) {
                                            filterParams = `${filterParams}${filter.APIField}=${entry.value}&`
                                        }
                                    }
                                    break
                                default:
                                    break
                            }
                            break
                        case 'single-select':
                            switch (filter.config.variant) {
                                case 'list':
                                    if (true) {
                                        filterParams = `${filterParams}${filter.APIField}=${filter.value}&`
                                    }
                                    break
                                case 'dropdown':
                                    if (true) {
                                        if (filter.value) {
                                            filterParams = `${filterParams}${filter.APIField}=${filter.value}&`
                                        }
                                    }
                                    break
                                default:
                                    break
                            }
                            break
                        case 'range':
                            if (true) {
                                filterParams = `${filterParams}${filter.APIField}=${filter.value.lower}&`
                            }
                            break
                        default:
                            break
                    }
                }
            }
        }

        const searchParam = searchText && searchText.trim().length > 0 ? `&search=${encodeURIComponent(searchText.trim())}` : ''

        let response;

        try {
            response = await fetch(
                `${process.env.REACT_APP_API_URL}/provider?&page=${page ? page : 1}${filterParams.length > 0 ? '&' + filterParams : ''}${searchParam}&userInteractionSearch=${userInteractionSearch ? 'true' : 'false'}`,
                {
                    method: 'GET',
                    headers: {
                        'Access-Control-Request-Method': 'GET'
                    }
                }
            );
        } catch (error) {
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-connection-timeout',
                source: ` - ${error.message}`
            }
            throw error;
        }

        let parsedResponse;
        try {
            parsedResponse = await response.json();
        } catch (error) {
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-bad-response',
                source: `${response.status} ${response.statusText}`
            }
            throw error;
        }

        if (response.status !== 200) {
            const error = new Error();
            switch (response.status) {
                case 400:
                case 415:
                    error.clientStatusMessage = {
                        variant: 'danger',
                        i18nKey: 'error.client-bad-request',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
                    break;
                default:
                    error.clientStatusMessage = {
                        variant: 'danger',
                        i18nKey: 'error.api-bad-response',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
            }
            console.log(error);
            throw error;
        }

        return parsedResponse;
    }
}

export default useGetProvidersPage;
